import { Snippet as AlgoliaSnippet } from 'react-instantsearch-dom';
import { THighlightSnippetProps } from 'components/Base/Algolia/types';

const Snippet = ({ hit, attribute }: THighlightSnippetProps): JSX.Element => {
  return <AlgoliaSnippet hit={hit} attribute={attribute} tagName='mark' />;
};

export default Snippet;
